export class AuditLog {
  static fromJson(json: any): AuditLog {
    return new AuditLog(
      json.id,
      json.timestamp,
      json.affectedArea,
      json.action,
      json.affectedId,
      json.message,
      json.userId,
      json.user
    );
  }

  static fromJsonArray(array): AuditLog[] {
    return array.map(AuditLog.fromJson);
  }

  constructor(
    public id: number,
    public timestamp: Date,
    public affectedArea: string,
    public action: string,
    public affectedId: string,
    public message: string,
    public userId: number,
    public user: string
  ) {}
}

export class AuditLogResponse {
  public auditLogs: AuditLog[];
  public total: number;
}
